import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

type TProps = {
  unreadRef: React.RefObject<HTMLDivElement>;
};

export const ChatUnreadMessagesInfo: React.FC<TProps> = ({ unreadRef }) => {
  return (
    <div className={styles['container']} data-testid="chat_unread_messages_info" ref={unreadRef}>
      <UIText3 color="black_60">Непрочитанные сообщения</UIText3>
    </div>
  );
};
